import React from "react";
import { Link } from "react-router-dom";
import { currencyFormatter } from "../../utils/display";

export default ({ activePanel, id, payment }) => {
  const paymentCards =
    payment.cards &&
    payment.cards.length &&
    payment.cards.reduce(
      (prevCard, currentCard) => prevCard + Number(currentCard.amount),
      0
    );
  const paymentDeductions =
    payment.deductions &&
    payment.deductions.length &&
    payment.deductions.reduce(
      (prevDed, currentDed) => prevDed + Number(currentDed.amount),
      0
    );
  const paymentAdjustments =
    payment.adjustments &&
    payment.adjustments.length &&
    payment.adjustments.reduce(
      (prevAdj, currentAdj) => prevAdj + Number(currentAdj.amount),
      0
    );
  const shippingReimbursements = payment.shippingReimbursements;
  const PayoutAmountClassName =
    payment.amount > 0 ? "positiveNumber" : "negativeNumber";
  return (
    <div>
      <div
        className={
          activePanel === id && Object.keys(payment).length
            ? "animated fadeIn panel-selected"
            : "animated fadeOut"
        }
      >
        {payment.orders &&
          payment.orders.length &&
          payment.orders.map((order) => (
            <div className="activity-sub-section activity-grey-sub-heading flex-center">
              <div className="flex-center format-lg-screen">
                <span className="mar-r-5">Associated Order ID:</span>
                <Link
                  to={`/account/orders/${order.id}`}
                  className="acct-pg-edit-link"
                  style={{ fontWeight: "bold" }}
                >
                  {order.orderId}
                </Link>
              </div>
            </div>
          ))}
        <div className="activity-payment-details activity-grey-sub-heading">
          {/* <span className="acct-txt-12 details-title">Payment Details</span> */}
          <table className="activity-payment-table">
            <tbody className="ledger-border-btm">
              {paymentCards && (
                <tr>
                  <td className="left-ledger-cell">Order Value: </td>
                  <td className="right-ledger-cell">
                    {currencyFormatter(paymentCards)}
                  </td>
                </tr>
              )}
              {paymentDeductions && (
                <tr>
                  <td className="left-ledger-cell">Deductions: </td>
                  <td className="right-ledger-cell">{`(${currencyFormatter(
                    paymentDeductions
                  )})`}</td>
                </tr>
              )}
              {paymentAdjustments && (
                <tr>
                  <td className="left-ledger-cell">Adjustments: </td>
                  <td className="right-ledger-cell">
                    {Math.sign(paymentAdjustments) === -1
                      ? `(${currencyFormatter(Math.abs(paymentAdjustments))})`
                      : currencyFormatter(paymentAdjustments)}
                  </td>
                </tr>
              )}
              {shippingReimbursements && (
                <tr>
                  <td className="left-ledger-cell">Reimbursements: </td>
                  <td className="right-ledger-cell">
                    {currencyFormatter(shippingReimbursements)}
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td className="left-ledger-cell">Total Payout:</td>
                <td className="right-ledger-cell">
                  <strong className={PayoutAmountClassName}>
                    {currencyFormatter(payment.amount)}
                  </strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};
